export default __webpack_public_path__ + "static/media/1336.cf501eea.png";